import { render, staticRenderFns } from "./AnalyticalTopproducts.vue?vue&type=template&id=4d45692b&scoped=true&"
import script from "./AnalyticalTopproducts.vue?vue&type=script&lang=js&"
export * from "./AnalyticalTopproducts.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticalTopproducts.vue?vue&type=style&index=0&id=4d45692b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45692b",
  null
  
)

export default component.exports